import { CollapseButton } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { cn } from "@msuite/ui/utils";
import type { Tables } from "@msuite/utils/types";
import { NoteText } from "@/components/notes";

/** Props Interface */
interface ProjectNoteProps {
	note: Tables<"projects">["note"];
}

export function ProjectNote({ note }: ProjectNoteProps) {
	/** State */
	const disclosure = useDisclosure();

	/** Render */
	const _note = note?.trim();

	/** Guard */
	if (!_note) return null;

	/** Render */
	return (
		<div
			className="mb-1 p-0.5 border-[0.5px] rounded-lg highlight-ring cursor-pointer"
			onDoubleClick={disclosure.onToggle}
		>
			<div
				className={cn(
					"flex flex-row items-baseline gap-2 px-2.5 py-1.5 rounded-md",
					"whitespace-pre",
				)}
			>
				<CollapseButton
					variant="plain"
					isOpen={disclosure.isOpen}
					onToggle={disclosure.onToggle}
					className="translate-y-[1.5px]"
				/>
				<NoteText
					note={_note ?? "--"}
					className="text-sm"
					lineClamp={disclosure.isOpen ? undefined : 1}
				/>
			</div>
		</div>
	);
}
